export const baseURL = process.env.REACT_APP_BASEURL_BACKOFFICE;
export const baseURLV1 = process.env.REACT_APP_BASEURL_BACKOFFICE + '/api/v1';
export const imageURL = process.env.REACT_APP_IMAGEURL;
